export default "__VITE_ASSET__Bnpr61qj__"